// extracted by mini-css-extract-plugin
export default {"show_more":"_1LYgScov","button_contents":"_1d_skevK","button_text":"_1ogwMK0l","button_icon":"_1lROnv6Z"};